module.exports = __webpack_public_path__ + "f28770392a46eba40aa9ad2b6fd01e1a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Homepage/homepage_face.png
 ** module id = 310
 ** module chunks = 0
 **/